import * as zod from 'zod';

export const ApiAuthData = zod.object({
  token: zod.string(),
  expiry: zod.number(),
});

export type ApiAuthData = zod.infer<typeof ApiAuthData>;
